import { useState } from "react";

// styles
import "./SideWindowTab.scoped.scss";

const SideWindowTab = ({ text, Icon = <></>, children, className = "", lessSpace = false, defaultState = true }) => {
	const [open, setOpen] = useState(defaultState);

	return (
		<div className={`tab ${className}`}>
			<div className="heading" onClick={() => setOpen(prev => !prev)}>
				{Icon} {text}
				<i className={open ? "fas fa-angle-right rotated" : "fas fa-angle-right"} />
			</div>
			<div className={open ? "content open" : "content"}>
				<div>
					{!lessSpace && <div className="space" />}
					{children}
					<div className="space" />
				</div>
			</div>
		</div>
	);
};

export default SideWindowTab;
